import { Modal } from 'antd';
import React, { useEffect } from 'react';
import { useUserPolicy } from '../../../user-policy';
import { buscar, confirmarLeitura } from '../../../services/notificacoes';

const openNotifications = (notificacoes) => {
  notificacoes.forEach((notification) => {
    Modal.info({
      centered: true,
      width: 560,
      title: notification.titulo,
      // eslint-disable-next-line react/no-danger
      content: <div dangerouslySetInnerHTML={{ __html: notification.mensagem }} />,
      okText: 'Ok',
      onOk: async () => {
        await confirmarLeitura(notification.id);
      },
    });
  });
};

function Notificacoes() {
  const { userAccount } = useUserPolicy();

  useEffect(() => {
    if (userAccount) {
      buscar().then((notificacoes) => {
        if (notificacoes && notificacoes.length) {
          openNotifications(notificacoes);
        }
      });
    }
  }, [userAccount]);

  return <span />;
}

export default Notificacoes;
